import config from "../config"
const baseUrl = config.base_url + "z_farm_work_order/"
export default {
    page: {
        url: baseUrl + "serviceRecords/{page}/{limit}",
        type: "post",
    },
    farmWorkTypeStatistics: {
        url: baseUrl + "farmWorkTypeStatistics",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
} 